<template>
	<div>
		<b-toast id="toast-check-modal-time-zone" variant="none" no-close-button toaster="b-toaster-top-center">
			<img src="@/assets/img/ico-check.png" style="margin-right: 10px; margin-top: -2px"/>
			{{ message }}
		</b-toast>
		<b-toast id="toast-equis-modal-time-zone" variant="none" no-close-button toaster="b-toaster-top-center">
			<img src="@/assets/img/ico-equis.png" style="margin-right: 10px; margin-top: -2px" />
			{{ message }}
		</b-toast>
		<b-modal id="modal-time-zone" size="md" :hide-body="true"  :centered="true" @hidden="updateFlagView">
			<template #modal-header="{ close }">
                <img class="close" src="@/assets/img/close_red.png" @click="close()">
				<h4> {{$t('modals.time-zone.h4', {GMT: gmt, TIMEZONE: timeZoneName})}}</h4>	
            </template>
			<template #modal-footer>
				<div class="buttons" style="display: flex;justify-content: flex-end;">
					<b-button class="ml-3" @click="changeTimeZone"  variant="link">
						<span v-if="!showSpinnerSave" style="color:#508adf">{{$t('modals.time-zone.btn-1')}}</span>
						<b-spinner style="width: 1rem !important; height: 1rem !important" v-else variant="light" label="Spinning">
						</b-spinner>
					</b-button>
					<b-button class="ml-3" @click="updateFlagView"  variant="link">{{$t('modals.time-zone.btn-2')}}</b-button>
					<b-button class="ml-3" @click="goConfiguration" variant="link">{{$t('modals.time-zone.btn-4')}}</b-button>			
				</div>
			</template>
		</b-modal>
	</div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";

export default {
	name:"modalTimeZone",
	data() {
		return {
			showSpinnerSave:false,
			message: '',
			gmt : '',
			timeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone
		}
	},
	props:{
		
	},
	computed:{
		User: {
				get() {
						return this.$store.state.user;
				},
				set(value) {
                	this.$store.commit('mutateUser', value);
            	}
		},
	},
	created() {
		let num = new Date().getTimezoneOffset();
		let sign = Math.sign(num)
		var hours = (parseInt(num) / 60);
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
	 	let hour = rhours < 10 ? '0'+rhours : rhours
		let minute = rminutes < 10 ? '0'+rminutes : rminutes
		let signString = sign == 1 ? '-' : '+';
		this.gmt = 'GMT'+signString+hour+':'+minute
	
	},
	methods: {
		goConfiguration(){
			this.$router.push({ name: `setting` }).catch(err => {});
			this.$bvModal.hide("modal-time-zone");
		},
		updateFlagView(){
			this.$store.commit("mutateFlagViewModalTimeZone", false);
			this.$bvModal.hide("modal-time-zone");
		},
		changeTimeZone(){
			this.showSpinnerSave = true;
			let json = {
				Id:this.User.id,
				TimeZoneName: this.timeZoneName
			}

            baseInstanceAxios
            .post(`${this.apiURL}/resources/Persons/UpdateTimeZone`, json)
            .then(response => {
                this.showSpinnerSave = false;
				this.message = this.$t('valid.1');
				this.User.timeZoneName =  this.timeZoneName;
				this.$bvToast.show("toast-check-modal-time-zone");
				this.$bvModal.hide('modal-time-zone');
            })
            .catch(err =>{
                this.showSpinnerSave = false;
                this.message = this.$t('error.1');
                this.$bvToast.show("toast-equis-modal-time-zone");
            }) 
		},
    }
}
</script>